import { PartnersList } from '@/components/PartnersList';

export const PartnersMobile = () => {
	return (
		<div className="relative block md:hidden">
			<PartnersList />
		</div>
	);
};
